"use client";
import { Badge } from "../../../../components/ui/badge";
import {
  Avatar,
  AvatarFallback,
} from "../../../../components/ui/avatar";
import { Progress } from "../../../../components/ui/progress";
import { cn } from "../../../../helper/utilityHelper";
import { Icon } from "@iconify/react";
import Utility from "../../../../helper/utilityHelper";
import avatarImg from "../../../../assets/images/logo/avatarImg.jpg";

const CustomerCard = ({ item, index }) => {
  const { name, totalCourtBookings, color, amount, phone, image } = item;

  return (
    <div
      className={cn({
        "order-2 md:-mt-8": index === 1,
        "order-1": index === 2,
        "order-3": index === 3,
      })}
    >
      <div className={`bg-${color}/10 relative p-6 pt-12 rounded`}>
        <div className="absolute -top-8 left-1/2 -translate-x-1/2">
          <div className="relative inline-block ring ring-yellow-400 rounded-full">
            {index === 1 && (
              <span className="absolute -top-[29px] left-1/2 -translate-x-1/2">
                <Icon
                  icon="ph:crown-simple-fill"
                  className="h-10 w-10 text-yellow-400"
                />
              </span>
            )}
            <Avatar className="h-16 w-16">
              <img
                src={image ? Utility.getImagePath(image) : avatarImg}
                alt={name || "Customer"}
                className="w-full h-full object-cover rounded-full"
              />
              <AvatarFallback className="bg-primary/20 text-primary font-semibold">
                {name ? name.charAt(0).toUpperCase() : "U"}
              </AvatarFallback>
            </Avatar>
            <Badge className="w-[18px] h-[18px] bg-warning/90 text-[10px] font-semibold p-0 items-center justify-center absolute left-[calc(100%-14px)] top-[calc(100%-20px)] bg-yellow-400">
              {index}
            </Badge>
          </div>
        </div>
        <div className="flex flex-col items-center gap-2">
          <div className="text-base font-semibold text-default-900 mb-1 whitespace-nowrap text-center">
            {name}
          </div>
          <Badge className="bg-primary/80">PKR {amount}</Badge>
        </div>

      </div>
    </div>
  );
};

export default CustomerCard;
